export default "__VITE_ASSET__D5s1VM6q__"